import $ from 'jquery';
window.require(['Magento_Customer/js/model/authentication-popup'], function (authenticationPopup) {
  $(document).on('click', '.js-pdp-login', function () {
    return authenticationPopup.showModal();
  });
});